import { motion } from "framer-motion";
import { GALLERY_ITEMS } from "@/siteConfig";

const Gallery = () => (
    <section id="gallery" data-testid="gallery-section" className="relative py-24 sm:py-32">
        <div className="mx-auto max-w-6xl px-4 sm:px-6">
            <motion.div
                initial={{ opacity: 0, y: 24 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-80px" }}
                transition={{ duration: 0.7 }}
                className="mb-14 flex flex-wrap items-end justify-between gap-4"
            >
                <div>
                    <p className="mb-3 text-xs font-bold uppercase tracking-[0.25em] text-amber-500">
                        من شغلنا
                    </p>
                    <h2 className="font-display text-3xl font-black text-white sm:text-4xl">
                        صور من ميدان العمل
                    </h2>
                </div>
                <p className="max-w-sm text-sm text-gray-400 sm:text-base">
                    جميع ماركات السيارات — برمجة ونسخ وفتح، بخدمة متنقلة في كل جدة.
                </p>
            </motion.div>

            <div className="grid grid-cols-2 gap-4 md:grid-cols-4">
                {GALLERY_ITEMS.map((item, i) => (
                    <motion.figure
                        key={i}
                        initial={{ opacity: 0, y: 30 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        viewport={{ once: true, margin: "-40px" }}
                        transition={{ duration: 0.6, delay: i * 0.08 }}
                        data-testid={`gallery-image-${i}`}
                        className={`gallery-card group relative cursor-pointer overflow-hidden rounded-3xl border border-white/8 ${
                            i === 0 ? "col-span-2 row-span-2 h-full min-h-[22rem]" : "h-52 sm:h-64"
                        }`}
                    >
                        <img
                            src={item.url}
                            alt={item.title}
                            loading="lazy"
                            className="absolute inset-0 h-full w-full object-cover"
                        />
                        <div className="absolute inset-0 bg-gradient-to-t from-[#0B0F17]/95 via-[#0B0F17]/20 to-transparent" />
                        <figcaption className="gallery-caption absolute right-0 bottom-0 left-0 p-5">
                            <span className="mb-2 inline-block rounded-full bg-amber-500/15 px-3 py-1 text-[11px] font-bold text-amber-400">
                                {item.category}
                            </span>
                            <p className="font-display text-sm font-extrabold text-white sm:text-base">
                                {item.title}
                            </p>
                        </figcaption>
                    </motion.figure>
                ))}
            </div>
        </div>
    </section>
);

export default Gallery;
